import Box from "@mui/material/Box";
import FilterComponent from "../../../../../ReusableFIlterComponent/FilterComponent";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  setGoalsRequestedBy,
  setSelectedDevice,
  setSelectedGoalsDate,
} from "../../../../../../features/pageSpeedPerformanceSlice";

interface Props {
  tableData: any;
}

export default function QuaterlyGoalFilter({ tableData }: Props) {
  const [searchDevice, setSearchDevice] = useState("");
  const [searchGoalsRequestedBy, setSearchGoalsRequestedBy] = useState("");
  const dispatch = useDispatch();
  const { selectedDevice, goalsRequestedBy, selectedGoalsDate } = useSelector(
    (state: any) => state.pageSpeedPerformance
  );
  const filterConfig = [
    {
      key: "date",
      label: "Select Date Range",
      filterName: "created",
      data: tableData,
      selectedOption: selectedGoalsDate,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setSelectedGoalsDate(updatedSelection)),
      count: 0,
      colorSelected:
        selectedGoalsDate !== null && selectedGoalsDate.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: false,
      isDateRangeFilter: true,
    },
    {
      key: "device",
      label: "Select a device",
      searchTerm: searchDevice,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchDevice(e.target.value),
      selectedOption: selectedDevice,
      filterName: "device",
      data: tableData,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setSelectedDevice(updatedSelection)),
      count: selectedDevice && selectedDevice?.length,
      colorSelected:
        selectedDevice !== null && selectedDevice?.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: false,
    },
    {
      key: "request by",
      label: "Select a user",
      searchTerm: searchGoalsRequestedBy,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchGoalsRequestedBy(e.target.value),
      selectedOption: goalsRequestedBy,
      filterName: "created_by",
      data: tableData,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setGoalsRequestedBy(updatedSelection)),
      count: goalsRequestedBy && goalsRequestedBy.length,
      colorSelected:
        goalsRequestedBy !== null && goalsRequestedBy?.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
  ];

  const clearFilters = () => {
    dispatch(setSelectedDevice(null));
    dispatch(setGoalsRequestedBy(null));
    dispatch(setSelectedGoalsDate([]));
    setSearchDevice("");
    setSearchGoalsRequestedBy("");
  };

  return (
    <Box data-tracker="161" sx={{ paddingTop: "10px" }}>
      <FilterComponent
        filterConfig={filterConfig}
        clearFilters={clearFilters}
        paginationKey="quarterlyGoalsPage"
      />
    </Box>
  );
}
